import { FC } from 'react';
import styled from 'styled-components';
import { useBreakpoints } from '../../../utils';
import { ButtonA } from './style';
interface HeaderButtonLinkProps {
  children: React.ReactNode;
  onClick: () => void;
  isActive: boolean;
}

// Filter chip: square, outlined; the selected one is filled.
const Chip = styled(ButtonA)<{ isActive: boolean }>`
  min-height: 36px;
  padding: 6px 14px;
  border: 1px solid ${(p) => (p.isActive ? p.theme.colors.general.primary : p.theme.colors.border.dark)};
  &:hover {
    border-color: ${(p) => p.theme.colors.general.primary};
  }
`;

const HeaderButtonLink: FC<HeaderButtonLinkProps> = ({ onClick, children, isActive }) => {
  const { isMobileScreen } = useBreakpoints();
  return (
    <Chip
      onClick={onClick}
      isActive={isActive}
      aria-pressed={isActive}
      weight={'medium'}
      size={isMobileScreen ? 'xxs' : 'xs'}
      fullWidth={false}
      center={true}
      color={isActive ? 'white' : 'black'}
      active={false}
      hasHover={false}
      background={isActive ? 'primary' : 'white'}
    >
      {children}
    </Chip>
  );
};

export default HeaderButtonLink;
